Bingo.ContactBoxTopics = {};

Bingo.ContactBoxTopics.init = ($forms, $values) => {
    $forms.each(function () {
        const $select = $(this).find('select[name=topics]').first();
        const $text = $(this).find('textarea[name=text]').first();
        $select.on('change', function () {
            $text.val($values[this.value]);
        });
    });
};
